import api from "./api";

class BusinessUnitAttivitaTimesheetVociSpesaManager {

    businessUnitAttivitaTimesheetVociSpesaList(config?: any) {
        return api.get(`/bu_at_vs`, config)
    }

    businessUnitAttivitaTimesheetVociSpesa(id: number | string) {
        return api.get(`/bu_at_vs/${id}`)
    }

    create(data:any) {
        return api.post(`/bu_at_vs/`, data)
    }

    update(id: number | string, data:any) {
        return api.put(`/bu_at_vs/${id}`, data)
    }

    delete(id: number | string) {
        return api.delete(`/bu_at_vs/${id}`)
    }

    list = this.businessUnitAttivitaTimesheetVociSpesaList
    retrieve = this.businessUnitAttivitaTimesheetVociSpesa
    paginatedList = this.list
}

const businessUnitAttivitaTimesheetVociSpesaManager = new BusinessUnitAttivitaTimesheetVociSpesaManager()

export default businessUnitAttivitaTimesheetVociSpesaManager
